"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitSupport = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const store_1 = require("client/modules/users/store");
const React = require("react");
const react_1 = require("react");
require("./new-support.less");
const url = "https://support.themedportal.com/support/tickets/new";
class SubmitSupport extends react_1.Component {
    render() {
        const email = store_1.usersStore.user.value && `${store_1.usersStore.user.value.email}`;
        // console.log(email);
        return (React.createElement("div", { className: "submit-support" },
            React.createElement(React.Fragment, null,
                React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                    React.createElement("div", { className: "support__title-wrapper" },
                        React.createElement(kpi_title_1.KpiTitle, { label: "Submit a Bug/Issue" }))),
                React.createElement("object", { data: url, type: "text/html", className: "support-iframe-style" }))));
    }
}
exports.SubmitSupport = SubmitSupport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/support/modules/new-support/new-support.tsx
// module id = 4128
// module chunks = 0